/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { SeminarRequestReservations, deleteRequestReservations } from '../../apis/admin/seminar';
import useForm from '../../hooks/useForm';
import { getParams } from '../../utils/params';
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';
import Filters from '../Filters';
import { ControlTable } from '../Table';
import { transformMobile } from '../../utils/validator/mobile';
import RequestReservation from './RequestReservation';

const RequestReservations = () => {

  const [filters] = useState([
    {
      title: "신청자명",
      key: "search.userName",
      options: {
        placeholder: "신청자명 입력",
      },
    },
    {
      title: "세미나명",
      key: "search.requestName",
      options: {
        placeholder: "세미나명 입력",
      },
    },
    {
      title: "결제상태",
      key: "search.paymentStatus",
      type: "select",
      options: {
        list: [
          { label: "전체", value: "all" },
          { label: "결제", value: "true" },
          { label: "미결재", value: "false" },
        ]
      }
    },
    {
      title: "예약상태",
      key: "search.approvalStatus",
      type: "select",
      options: {
        list: [
          { label: "전체", value: "all" },
          { label: "대기", value: "wait" },
          { label: "예약대기", value: "reservationWait" },
          { label: "예약완료", value: "approval" },
          { label: "반려", value: "denied" },
        ]
      }
    },
  ]);

  const [fields] = useState([
    { title: "세미나 모집 제목", key: 'seminarRequest.title' },
    { title: "강연자", key: 'seminarRequest.lecturer' },
    { title: "신청자명", key: 'applicantName' },
    { title: "신청자 연락처", key: 'applicantMobile', onValue: (v) => transformMobile(v) },
    { title: "참석인원", onValue: (_v, _f, data) => `${data.participants.length + 1}명` },
    {
      title: "예약상태",
      key: 'approvalStatus',
      onValue: (data) => {
        let result = '';
        switch (data) {
          case "approval":
            result = "예약완료";
            break;
          case "wait":
            result = "대기";
            break;
          case "denied":
            result = "반려";
            break;
          default:
            break;
        }
        return result;
      }
    },
    {
      title: "결제상태",
      key: 'paymentStatus',
      onValue: (data) => {
        return data ? "완료" : "미결재";
      }
    },
    { title: "신청일", key: 'createdTime', type: "date" },
    {
      type: 'button',
      size: 'x-sm',
      color: 'gray-line',
      label: '상태변경',
      onClick: ({ data }) => {
        setDetailOpen(true);
        setSelectedItem(data);
      }
    },
  ]);

  const [tableButtons, setTableButtons] = useState();
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const {
    form,
    setSubmit,
    handleOnChange,
    // handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm({
    order: [
      {
        idx: "desc"
      },
    ],
    search: {
      approvalStatus: "all",
      paymentStatus: -1,
    },
    page: 0,
    limit: 10,
  });

  const submit = (param) => {
    const params = getParams(param);
    SeminarRequestReservations({
      ...params,
      search: {
        ...params.search,
        approvalStatus: param?.search?.approvalStatus,
        paymentStatus: param?.search?.paymentStatus
      }
    }).then(
      (res) => {
        setList(res.rows);
        setTotal(res.count);
      }).catch((err) => {
        console.error(err.response);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  useEffect(() => {
    setTableButtons([
      {
        label: "예약정보 삭제",
        disabled: isEmpty(selectedList),
        color: "red",
        action: () => {
          const message = `"${selectedList[0]?.user?.name}" ${selectedList.length - 1 > 0 ? `님 외 ${selectedList.length - 1}개` : ""}님의 예약정보를 삭제하시겠습니까?`;

          systemAlert(message, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                color: 'red',
                onClick: () => {
                  const idx = selectedList.map(item => item.idx);
                  deleteRequestReservations({ idx }).then(() => {
                    toast.success("삭제되었습니다.");
                    submit && submit(form);
                    setSelectedList([]);
                  }).catch(err => {
                    console.error(err.response);
                  }).finally(() => {
                    setIsLoading(false);
                  });
                }
              }
            ]
          });
        },
      }
    ]);
  }, [selectedList]);

  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        buttons={tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
      />

      <RequestReservation
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={filterSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </>
  );
};

export default RequestReservations;